import React from "react";

export function ShareIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
    >
      <path
        d="M11 4.66663C11.9665 4.66663 12.75 3.88312 12.75 2.91663C12.75 1.95013 11.9665 1.16663 11 1.16663C10.0335 1.16663 9.25 1.95013 9.25 2.91663C9.25 3.88312 10.0335 4.66663 11 4.66663Z"
        stroke="#8C8E95"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 8.75C4.9665 8.75 5.75 7.9665 5.75 7C5.75 6.0335 4.9665 5.25 4 5.25C3.0335 5.25 2.25 6.0335 2.25 7C2.25 7.9665 3.0335 8.75 4 8.75Z"
        stroke="#8C8E95"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 12.8334C11.9665 12.8334 12.75 12.0499 12.75 11.0834C12.75 10.1169 11.9665 9.33337 11 9.33337C10.0335 9.33337 9.25 10.1169 9.25 11.0834C9.25 12.0499 10.0335 12.8334 11 12.8334Z"
        stroke="#8C8E95"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.51172 7.88086L9.49589 10.2025"
        stroke="#8C8E95"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.49005 3.79749L5.51172 6.11915"
        stroke="#8C8E95"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
